import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { SearchHeader } from '@ifca-root/react-component/src/components/Header/SearchHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  Menu,
  MenuItem,
} from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import { commonList } from 'containers/GeneralSettingModule/Common/CommonForm'
import {
  AcctPermission,
  CommonStatus,
  GetTaxSchemeNewListingDocument,
  useActiveInactiveCommonTaxSchemeMutation,
  useGetTaxSchemeNewListingLazyQuery,
} from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import createHistory from 'history/createBrowserHistory'
import React, { useContext, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory } from 'react-router'

export const TaxSchemeListing = () => {
  const history = useHistory()
  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()
  const [search, setSearch] = useState(localStorage.getItem('searchFilter'))
  const [totalLength, setTotalLength] = useState(0)
  const [timer, setTimer] = useState(null)
  const { handlePermDisabled } = usePermissionChecker()
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const [deleteDialog, setDeleteDialog] = useState(false)
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const getSearch = localStorage?.getItem('searchFilter')
  const {
    filteredList,
    handleSearch,
    setOriginalListing,
    originalList,
  } = useFuseSearch()

  const [
    loadTaxSchemeListing,
    {
      loading: TaxSchemeListingLoading,
      data: { getTaxSchemeListing } = {
        getTaxSchemeListing: [],
      },
    },
  ] = useGetTaxSchemeNewListingLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getTaxSchemeListing }) => {
      setTotalLength(getTaxSchemeListing.length)
    },
  })

  const [
    activeInactiveTaxScheme,
    { loading: ActiveInactiveTaxSchemeLoading },
  ] = useActiveInactiveCommonTaxSchemeMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
    },
  })

  function changeDelay(change) {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }
    setTimer(
      setTimeout(() => {
        setOriginalListing([])
        loadTaxSchemeListing({
          variables: {
            searchValue: change,
          },
        })
      }, 1000)
    )
  }

  useEffect(() => {
    loadTaxSchemeListing({
      variables: {
        ...(getSearch && { searchValue: getSearch }),
      },
    })
  }, [])

  useEffect(() => {
    const newHistory = createHistory()
    if (newHistory.location.state && newHistory.location.state['success']) {
      let state = { ...(newHistory.location.state as object) } as any
      delete state['success']
      newHistory.replace({ ...newHistory.location, state })
    }
  }, [])

  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  return (
    <>
      {TaxSchemeListingLoading && <Loading />}
      {ActiveInactiveTaxSchemeLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/common-setting`)
          localStorage.removeItem('searchFilter')
        }}
        smTitle="Common Settings"
        title={user?.accountName}
        routeSegments={[
          { name: 'General Setting' },
          { name: 'Tax Scheme', current: true },
        ]}
      />
      <div className="search-filter with-dropdown-filter">
        <SearchHeader
          title="Tax Scheme Listing"
          value={`${totalLength}`}
          search
          onChangeAction={e => {
            localStorage.setItem('searchFilter', e.target.value)
            changeDelay(e.target.value)
          }}
          defaultValue={search}
          isDefaultValue={!!search}
          onCloseAction={() => {
            handleSearch('', [])
            localStorage.removeItem('searchFilter')
            setOriginalListing([])
            loadTaxSchemeListing()
          }}
        />
      </div>
      <ContentWrapper float>
        <List className="core-list">
          {getTaxSchemeListing.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList.length}
              next={() => {}}
              hasMore={false}
              style={{ padding: '8px 6px' }}
              loader={
                <div style={{ textAlign: 'center' }}>
                  <CircularProgress />
                </div>
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {getTaxSchemeListing.map((el, index) => (
                <ListItem key={index}>
                  {commonList(el, 'Common Tax Scheme', el?.commonStatus)}
                  <ListItemSecondaryAction>
                    <IconButton
                      edge="end"
                      aria-label="more"
                      aria-controls="menu-list"
                      aria-haspopup="true"
                      onClick={e => handleClick(e, el.id, index, el)}
                    >
                      <MoreVert />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </InfiniteScroll>
          )}
        </List>
        <FloatButton
          disabled={handlePermDisabled({
            permEnum: AcctPermission.CommonSettingTaxSetupUpdate,
          })}
          onClick={() =>
            history.push({ pathname: '/common-setting/tax-scheme/add' })
          }
        />
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          {menu?.obj?.commonStatus === 'ACTIVE' && (
            <>
              <MenuItem
                onClick={() =>
                  history.push({
                    pathname: `/common-setting/tax-scheme/${menu?.obj?.id}/view`,
                    state: menu?.obj,
                  })
                }
              >
                View
              </MenuItem>
              <MenuItem
                onClick={() =>
                  history.push({
                    pathname: `/common-setting/tax-scheme/${menu?.obj?.id}/edit`,
                    state: menu?.obj,
                  })
                }
                disabled={handlePermDisabled({
                  permEnum: AcctPermission.CommonSettingTaxSetupUpdate,
                })}
              >
                Edit
              </MenuItem>
            </>
          )}
          <MenuItem
            onClick={() => {
              setDeleteDialog(true)
            }}
            disabled={handlePermDisabled({
              permEnum: AcctPermission.CommonSettingTaxSetupUpdate,
            })}
          >
            {menu?.obj?.commonStatus === 'ACTIVE' ? 'Deactivate' : 'Activate'}
          </MenuItem>
        </Menu>
      </ContentWrapper>
      {/* ACTIVE / INACTIVE DIALOG */}
      <CommonDialog
        fullWidth={true}
        open={deleteDialog}
        onClose={() => setDeleteDialog(false)}
        sections={{
          header: {
            dynamic: (
              <div>
                <div className="dialog-dynamic-content">
                  <div className="session">
                    <div className="flex session">
                      <div
                        className="dialog-title  c-orange flex-space"
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        {menu?.obj?.name}
                      </div>
                      <div
                        className="dialog-title  c-orange"
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        {menu?.obj?.commonStatus === 'ACTIVE'
                          ? 'Deactivate'
                          : 'Activate'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ),
          },
          body: () => (
            <>
              <Grid container spacing={1}>
                <Grid item xs={6} className="fw-medium desc ">
                  <div className="content-wrap left">
                    <div
                      className="desc"
                      style={{ color: '#878787', fontSize: '10px' }}
                    >
                      Name
                    </div>
                    <div
                      className="mdDesc text-noflow"
                      style={{ fontSize: '11px', width: '100px' }}
                    >
                      {menu?.obj?.name}
                    </div>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={6} className="fw-medium desc ">
                  <div className="content-wrap left">
                    <div
                      className="desc"
                      style={{ color: '#878787', fontSize: '10px' }}
                    >
                      Description
                    </div>
                    <div
                      className="mdDesc text-noflow"
                      style={{ fontSize: '11px', width: '100px' }}
                    >
                      {menu?.obj?.description}
                    </div>
                  </div>
                </Grid>
              </Grid>
            </>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => setDeleteDialog(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                    setDeleteDialog(false)
                    activeInactiveTaxScheme({
                      variables: {
                        taxSchemeId: menu?.obj?.id,
                        commonStatus:
                          menu?.obj?.commonStatus === 'ACTIVE'
                            ? CommonStatus.Inactive
                            : CommonStatus.Active,
                      },
                      refetchQueries: [
                        { query: GetTaxSchemeNewListingDocument },
                      ],
                    })
                  },
                  variant: 'contained',
                  color: 'primary',
                  type: 'submit',
                },
              },
            ],
          },
        }}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
